import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75l1.5-6h13.5l1.5 6v7.5a3 3 0 01-3 3H3.75V9.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M12 4v6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.26 14.694c-.64-.474-.154-1.414.02-1.694-.314.347-.628.687-.868 1.06-.38.587-.546 1.234-.286 1.647.466.747 1.58.4 2.287.1L17 13.027l-6.507 1.72c-.547.14-.987.127-1.234-.053z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75l1.5-6h13.5l1.5 6v7.5a3 3 0 01-3 3H3.75V9.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M12 4v6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.26 14.694c-.64-.474-.154-1.414.02-1.694-.314.347-.628.687-.868 1.06-.38.587-.546 1.234-.286 1.647.466.747 1.58.4 2.287.1L17 13.027l-6.507 1.72c-.547.14-.987.127-1.234-.053z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 19.5l3-12h27l3 12v15a6 6 0 01-6 6h-27v-21z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 19.5h-33M24 8v12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.518 29.387c-1.28-.947-.306-2.827.04-3.387-.626.693-1.253 1.373-1.733 2.12-.76 1.174-1.094 2.467-.574 3.294.934 1.493 3.16.8 4.574.2L34 26.054l-13.015 3.44c-1.093.28-1.973.253-2.467-.107z"
  }))
};
export var MemberProduct = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});